import React from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import styles from './StudyNavigation.scss';
import LifecycleIndicator from 'components/common/Study/LifecycleIndicator';
import { Tabs } from 'components/common/Tabs/Tabs';
import { GoBack } from 'components/common/Link';
import { Button, BUTTON } from '../../../../components/common/Button/Button';
const { SIZE, COLOR, BGCOLOR } = BUTTON;

const StudyNavigation = props => {
    const style = props.fixedNav ? styles.stuckStudyNavContainer : styles.studyNavigationContainer;
    
    const handleDownloadBinder = () => {
        if (props.binderId && !props.isRequestingExport) {
            props.requestBinderExport(props.binderId);
        }
    };

    return (
        <div className={style} data-cy="StudyNavigation">
            <GoBack
                data-test-id='hyp-study-navigation-back'
                to={props.complion4FlagEnabled ? '/binders/study' : '/studies'}
                data-cy="StudyNavigation-studies"
            >
                Back to {props.complion4FlagEnabled ? 'Binders' : 'Studies'} List
            </GoBack>
            <div className={styles.studyHeader} data-cy="StudyNavigation-div">
                <StudyTitle
                    title={props.title}
                    type={props.type}
                />
                {props.hasDownloadBindersPermission && !(/central/i.test(props.title)) && (
                    <Button
                        text={'Download Binder'}
                        type={SIZE.PRIMARY}
                        color={COLOR.BLACK}
                        bgcolor={BGCOLOR.CLEAR}
                        outline={BUTTON.OUTCOLOR.GREY}
                        onClick={handleDownloadBinder}
                        disabled={props.isRequestingExport}
                        data-cy="DownloadSingleBinderButton-4.0"
                    />
                )}
            </div>
            <Tabs tabs={props.tabs} location={props.location} />
        </div>
    );
};

// Export unconnected component for testing
export { StudyNavigation };

export default connect(
    (state) => {
        // Check if user has the "Download Binders" system permission
        const hasDownloadBindersPermission = lodash.get(state, 'me.systemPermissions.downloadBinders', false);
        const isRequestingExport = lodash.get(state, 'binderExport.isRequesting', false);
        return {
            hasDownloadBindersPermission,
            isRequestingExport
        };
    }
)(StudyNavigation);

export const StudyTitle = props => (
    <div data-cy="StudyNavigation-StudyTitle">
        <h1 data-cy="StudyNavigation-h1">
            {props.title}
        </h1>
        <h2 data-cy="StudyNavigation-h2">
            {props.type}
        </h2>
    </div>
);

export const LifecycleStage = props => (
    <div className={props.className} data-cy="StudyNavigation-LifecycleStage">
        <h2>
            Lifecycle Stage
        </h2>
        <LifecycleIndicator
            withBackground={props.withBackground}
            title={props.stage}
        />
    </div>
);
